import React, { Component } from 'react'
import './styles.scss'
import * as Modals from '../../constants/common'
import Modal from 'react-modal'

class ErrorModal extends Component {
  constructor() {
    super()
    this.open = false
    this.state = {
      modal: Modals.loginError,
      showModal: false
    }
    this.close = this.close.bind(this)
    this.process = this.process.bind(this)
  }

  componentWillReceiveProps(np) {
    if (np.open) {
      const modalType = Modals[this.props.modalType]
      this.setState({ modal: modalType, showModal: true })
      this.open = true
    }
  }
  // Below functions are handling parent functions as required
  close() {
    this.open = false
    // pagePreserve flag is hanlded to keep user on same page
    this.props.closeModal(this.state.modal.pagePreserve)
  }

  process() {
    this.open = false
    this.props.closeModal(false)
  }

  render() {
    return (
      <div id="main">
        <Modal
          overlayClassName="Overlay"
          isOpen={this.open}
          id={this.props.modalType}
          ariaHideApp={false}
          className="main-modal modal-dialog-centered"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                {this.state.modal.showClose ? (
                  <div className="close" onClick={this.close}>
                    <span className="link">
                      <img alt="" src="/img/black_close_icon.svg" />
                    </span>
                  </div>
                ) : (
                  ''
                )}
                <img alt="" className="pop-bg-img" src="/img/gray-bg@3x.svg" />
                <div className="camera-box">
                  <img alt="" src={this.state.modal.icon} />
                </div>
              </div>
              <div className="modal-body">
                <h5 className="modal-title text-center">{this.state.modal.heading}</h5>
                <p className="text-center light-gray">{this.props.errorText ? this.props.errorText : this.state.modal.text}</p>
                {this.state.modal.showContact ? (
                  <div className="login-signup-link text-center">
                    <span>
                      Need help?{' '}
                      <a rel="noopener noreferrer" href="https://radiatorlabs.zendesk.com/hc/en-us/requests/new" target="_blank">
                        Contact Us
                      </a>
                    </span>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="modal-footer">
                <div className="col-md-12 text-center">
                  <span className="link" onClick={this.process} data-dismiss="modal">
                    {this.state.modal.buttonText}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
export default ErrorModal



// WEBPACK FOOTER //
// ./src/views/Modals/error.js